import {Box, Flex, Text, Divider, showMessage} from 'exsportia-components'
import React, {FC} from 'react'
import {useDispatch} from 'react-redux'

import {SessionSelectSession} from '../../api/class-session/types'
import {useLocale, useLuxon} from '../../utils/i18n'
import {Button} from '../../ui/components/button/button'
import {createWaitingListBookingRequest} from '../../services/booking/actions'
import {useModalActions} from '../../utils/modals'
import {useBookingLoader} from '../../services/booking/hooks'
import {WaitingListSessionInfo} from './waiting-list-session-info'

type Props = {
  session: SessionSelectSession
  venueId: string
  userId: string
  userName: string
  isMemberLoading: boolean
  isLoading: boolean
  isPast: boolean
  variant: 'waitingListBooked' | 'waitingListAvailable' | 'default'
  venueData: any
  memberId?: string
}

export const WaitingListModal: FC<Props> = ({
  session,
  venueId,
  userId,
  userName,
  venueData,
  memberId,
  variant,
  isMemberLoading,
  isLoading,
  isPast,
}) => {
  const {l} = useLocale()
  const dispatch = useDispatch()
  const {closeModal, openModal} = useModalActions()
  const {isLoading: isBookingLoading} = useBookingLoader()

  const handleJoin = () => {
    if (!session.permissionData?.validated) {
      showMessage(l('error'), 'error')
      return
    }
    dispatch(
      createWaitingListBookingRequest({
        data: {
          venueId,
          peopleAmount: 1,
          classId: session.classId,
          slot_id: session.uid,
          userId,
          name: userName,
          memberId,
          // A number: the notify cron filters `date_timestamp >= <ms>`, and Firestore never
          // matches a string against a number, so a string left the entry invisible to it.
          date_timestamp: Number(session.timestamp),
        },
        callback: () => {
          closeModal()
        },
        l,
      }),
    )
  }

  return (
    <Box>
      <Flex
        flexDirection='column'
        gap='16px'
      >
        <Text
          text={l('waitingListDescription' as any)}
          settings={{
            fontSize: '14px',
            color: 'text-secondary',
            lineHeight: '20px',
            textAlign: 'center',
            m: '8px 0 16px 0',
          }}
        />

        <WaitingListSessionInfo
          session={session}
          venueData={venueData}
          variant={variant as any}
          isMemberLoading={isMemberLoading}
          isLoading={isLoading}
          isPast={isPast}
        />

        <Button
          onClick={handleJoin}
          type='primary'
          isLoading={isBookingLoading}
          settings={{height: '40px'}}
        >
          {l('join')}
        </Button>

        <Text
          onClick={closeModal}
          text={l('close')}
          settings={{
            fontSize: '14px',
            color: 'primary',
            cursor: 'pointer',
            height: '40px',
            fontWeight: 600,
            textAlign: 'center',
          }}
        />
      </Flex>
    </Box>
  )
}
